module.exports = __webpack_public_path__ + "media/mypage/images/fa/2-0887373725745bd03ce334f0b951e926.jpg";